// Transient non-dismissable overlay actions can show during work. Sits above
// the modal stack. The host owns the visible/label state; this component is
// pure presentation.
//
// Not a modal — modals are dismissable, busy isn't. Intentionally separate
// to keep the semantics clear at the action layer.

export interface BusyOverlayProps {
  visible: boolean;
  label?: string | null;
}

export function BusyOverlay({ visible, label }: BusyOverlayProps) {
  if (!visible) return null;
  return (
    <div className="sd-busy" role="status" aria-live="polite">
      <div className="sd-busy__spinner" aria-hidden="true" />
      {label && <div className="sd-busy__label">{label}</div>}
    </div>
  );
}
